import { FieldGroup } from "./field-group";
import { FieldSet } from "./input";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";
import { FieldItem } from "../../types";

export const shouldShowDynamicOptionsPlaceholder = (field: FieldItem) =>
  (field.hasDynamicOptions || field.field?.dataSourceMapping) &&
  field.options?.length === 0;

export const DynamicOptionsPlaceholder = ({
  field,
  index,
  error,
  loading,
  disabled,
  isPreview,
}: Pick<
  FieldProps,
  "field" | "index" | "error" | "loading" | "disabled" | "isPreview"
>) => {
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading} className="text-ui">
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
      >
        <FieldSet uri={field.uri} error={error} errorId={errorId}>
          <div>
            {isPreview
              ? "Dynamic options are not visible in preview mode"
              : "Selection unavailable because the prerequisite question has not yet been answered"}
          </div>
        </FieldSet>
      </FieldGroup>
    </FieldWrapper>
  );
};
